// extracted by mini-css-extract-plugin
export default {"popularHeader":"NBqwDEpz","mobile":"mobile","popularTitle":"fE1p7uHj","searchWrapper":"ubeQalTw","searchTitle":"RogSuTVH"};